export const contactsData = {
    email: 'randhirrajak9431@gmail.com',
    phone: '+91-6204360389',
    address: 'Ranchi, Jharkhand',

    sheetAPI: ''
}